import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['clientDataSlice', 'ledgerReportSlice', 'selectedClientSlice',"postponedChecksSlice", "reportPeriodSlice", "documentCountsSlice", "mainPageDataSlice", "documentPageSlice", "journalEntryPageSlice", "paymentAcceptancePageSlice", "transactionDocumentPageSlice", "accountCardsTablePageSlice"]
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false // required for redux-persist to avoid non-serializable warnings
    })
});

const persistor = persistStore(store);
const { dispatch } = store;

export { store, persistor, dispatch };
